import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import { alignmentOptions } from 'src/utils';
import CustomMUISelect from '../components/CustomMUISelect';

const QuoteModule = ({
  alignment,
  showError,
  text,
  text_fr,
  handleChange,
  handleChangeRemoveError,
}) => {
  return (
    <>
      <CustomMUISelect
        name="alignment"
        label="Alignment"
        options={alignmentOptions}
        value={alignment}
        onChange={handleChange}
      />
      <Input
        error={showError && !text}
        autoFocus
        label="Text"
        variant="outlined"
        name="text"
        value={text}
        onChange={handleChangeRemoveError}
        helperText={showError && !text ? 'Required' : null}
        inputProps={{ maxLength: 200 }}
      />
      <Input
        label="Text (French)"
        variant="outlined"
        name="text_fr"
        value={text_fr}
        onChange={handleChange}
        inputProps={{ maxLength: 200 }}
      />
    </>
  );
};

export default QuoteModule;

const Input = styled(TextField)`
  width: 100%;
  margin: 15px 0;
`;
